import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import {routes} from '../../config/routes';
import {LoginPage} from '../components/pages/login/LoginPage';
import {RegisterPage} from '../components/pages/register/RegisterPage';
import {GenericErrorPage} from '../components/Error';
import {prefixWithLanguage} from '../components/Router/prefixWithLanguage';
import {AuthLayout} from './AuthLayout';

const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    errorElement: <GenericErrorPage />,
    children: [
      {
        path: prefixWithLanguage(routes.REGISTER_PATH),
        element: <RegisterPage />,
      },
      {
        path: prefixWithLanguage(routes.LOGIN_PATH),
        element: <LoginPage />,
      },
    ],
  },
]);

export const AuthRouter = () => {
  return <RouterProvider router={router} />;
};
